import React from "react";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Modal, Row, Spinner, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import { AccordionSummary, AccordionDetails, Accordion } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SelectAndExecute from "../SelectAndExecute";

const apartStuff = {
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: 10
};

const CareSessionDetails = ({
  bookingDetails,
  openAppntNotesModal,
  openClinicalNotesModal,
  sendSummaryReport,
  cancelBooking,
  markAsNoShow,
  rescheduleBooking,
  completeClinicalService,
  enterPaymentInfo
}) => {
  return (
    <Accordion defaultExpanded className="mb-4 rounded-none">
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" style={{ background: "#0000000F" }}>
        <Card.Header id="cardTitle" className=" w-100 border-0 bg-transparent ">
          <Row id="cardTitle  w-100">
            <Col>Care Session Details</Col>
          </Row>
        </Card.Header>
      </AccordionSummary>
      <AccordionDetails className="accordionDetails">
        <Card className="border-0 shadow-none">
          <Card.Body
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              marginBottom: 15
            }}
          >
            <Col
              style={{
                width: "65%",
                display: "flex",
                justifyContent: "flex-start",
                flexDirection: "column"
              }}
            >
              <Row style={apartStuff}>
                <Col style={{ fontWeight: "600", textAlign: "left" }}>Type of Booking</Col>
                <Col style={{ textAlign: "right" }}>{bookingDetails?.careType?.displayName ?? "unknown"}</Col>
              </Row>
              <Row style={apartStuff}>
                <Col style={{ fontWeight: "600", textAlign: "left" }}>Location Address</Col>
                <Col style={{ textAlign: "right" }}>{bookingDetails?.careLocation?.address ?? "unknown"}</Col>
              </Row>
              {bookingDetails?.careType?.name === "TELEMED_CONSULT" ? (
                <>
                  <Row style={apartStuff}>
                    <Col style={{ fontWeight: "600", textAlign: "left" }}>Meeting URL</Col>
                    <Col style={{ textAlign: "right" }}>{bookingDetails?.onlineMeetingUrl ?? "unknown"}</Col>
                  </Row>
                  <Row style={apartStuff}>
                    <Col style={{ fontWeight: "600", textAlign: "left" }}>Meeting Password</Col>
                    <Col style={{ textAlign: "right" }}>{bookingDetails?.onlineMeetingPwd ?? "unknown"}</Col>
                  </Row>
                  <Row style={apartStuff}>
                    <Col style={{ fontWeight: "600", textAlign: "left" }}>Meeting Mode</Col>
                    <Col style={{ textAlign: "right" }}>{bookingDetails?.consultMediumType ?? "unknown"}</Col>
                  </Row>
                  <Row style={apartStuff}>
                    <Col style={{ fontWeight: "600", textAlign: "left" }}>Planned Duration (in mins)</Col>
                    <Col style={{ textAlign: "right" }}>{bookingDetails?.plannedMins ?? "unknown"}</Col>
                  </Row>
                  <Row style={apartStuff}>
                    <Col style={{ fontWeight: "600", textAlign: "left" }}>Actual Duration (in mins)</Col>
                    <Col style={{ textAlign: "right" }}>{bookingDetails?.actualMins ?? "unknown"}</Col>
                  </Row>
                </>
              ) : null}
            </Col>
          </Card.Body>
        </Card>
      </AccordionDetails>
    </Accordion>
  );
};

export default CareSessionDetails;
